import "./ArrowButton.scss";
import { useEffect, useState } from "react";

const ArrowButton = ({ step, setStep }) => {
  const [isShaking, setIsShaking] = useState(false);
  const handleClick = () => {
    setStep(step + 1);
  };
  useEffect(() => {
    let intervalId;

    const startShakeWithInterval = () => {
      setIsShaking(true);

      intervalId = setInterval(() => {
        setIsShaking(false);
        setTimeout(() => {
          setIsShaking(true);
        }, 2000);
      }, 6000);
    };

    startShakeWithInterval();

    return () => {
      clearInterval(intervalId);
    };
  }, []);
  return (
    <span
      className={`arrow__down ${isShaking ? "shake" : ""}`}
      onClick={handleClick}
    >
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M25.3333 18.6667L16 28M16 28L6.66663 18.6667M16 28L16 4"
          stroke="white"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};
export default ArrowButton;
